import { Component } from "preact";
import PropTypes from "prop-types";
import { M_Configuration } from "../../../models/Models_Configuration";
import { withStoreConnection } from "../../components";
import { configurationSelector } from "../../../store/selectors/selectors";

/**
 * A public higher-order component to access the imperative API
 */
export const withConfiguration = ChildComponent => {
	class HOC extends Component {
		render() {
			return (
				<ChildComponent
					{...this.props}
				/>
			);
		}

		static get displayName() {
			return "withConfiguration(" + (ChildComponent.displayName || ChildComponent.name) + ")"
		}

		static get wrappedComponent() {
			return ChildComponent;
		}

		static get propTypes() {
			return {
				configuration: PropTypes.object,
			}
		}

		static get defaultProps() {
			return {
				configuration: M_Configuration,
			}
		}
	}

	const mapStateToProps = state => {
		return {
			configurationStates: configurationSelector.selectStates(state),
			configuration: configurationSelector.selectData(state),
		};
	};

	return withStoreConnection(mapStateToProps)(HOC);
};

export default withConfiguration;
